import { getDeviceSchema, PLUGIN } from "callable-data-objects";
import PluginSelect from "Components/Device/Plugin/PluginSelect";
import { CallableInput, CountrySelect } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { Field, Formik } from "formik";
import { useDevice } from "Hooks/Endpoints";
import APIAccountWebhookProvider from "Providers/APIWebhookProvider";
import React from "react";
import { Divider, Form, Header, Segment } from "semantic-ui-react";

const CreatePluginForm = () => {
  const { save, nextExtension, validateExtension, validateName } = useDevice();

  const initValues = {
    type: PLUGIN,
    name: "",
    extension: nextExtension,
    plugin: {
      plugin: "",
      data: "{}",
      countryCode: "gb",
      onTransfer: "HANGUP",
      onError: "HANGUP",
      onNoAnswer: "HANGUP",
      onBusy: "HANGUP",
      onFail: "HANGUP",
      onComplete: "HANGUP",
    },
  };

  return (
    <APIAccountWebhookProvider>
      <Segment>
        <Header as='h3'>Create Plugin</Header>
        <Divider />
        <Formik
          initialValues={initValues}
          validationSchema={getDeviceSchema(PLUGIN)}
          onSubmit={(values, actions) => {
            save(values);
          }}
        >
          {(props) => (
            <Form onSubmit={props.handleSubmit}>
              <Field
                name='name'
                label='Name'
                validate={validateName}
                component={CallableInput}
              />
              <Field
                name='extension'
                label='Extension'
                placeholder='100'
                type='number'
                validate={validateExtension}
                component={CallableInput}
              />
              <CountrySelect
                name='plugin.countryCode'
                label='Presentation Country'
              />
              <Field
                name='plugin.plugin'
                label='Hook'
                device={initValues}
                component={PluginSelect}
              />
              <FormSubmit name='Create Plugin' errors={props.errors} />
            </Form>
          )}
        </Formik>
      </Segment>
    </APIAccountWebhookProvider>
  );
};

export default CreatePluginForm;
